




























































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Guard, GuardStatus, UnavailableStatus } from "@/store/mobile/types";
import mobileApi from "@/services/api.mobile.service";

const Mobile = namespace("mobile");

@Component
export default class AvailabilityBanner extends Vue {
	// Call sign related accessors
	@Mobile.Getter("getCallSign") callSign: "";
	@Mobile.Getter("getOnDuty") onDuty: boolean;
	@Mobile.Getter("getIsCoverAvailable") isCoverAvailable: boolean;
	@Mobile.State(state => state.DispatchGuard.originalCallSign) originalCallSign: string;
	@Mobile.Getter("getUnavailableReason") unavailableReason: "";
	@Mobile.Getter("getUnavailableStatus") unavailableStatusId: number;
	@Mobile.Getter("getUnavailableStatuses") unavailableStatuses: UnavailableStatus[];
	@Mobile.Getter("getAvailableButtonDisabled") buttonDisabled: boolean;
	@Mobile.Getter("getStatus") guardStatus: string;
	@Mobile.Action loadUnavailableStatuses: any;
	@Mobile.Action guardAvailable: any;
	@Mobile.Action endCover: () => Promise<void>;
	@Mobile.Mutation setOnDuty: any;
	@Mobile.State(state => state.MobileMode) mobileMode: string;
	@Mobile.State(state => state.DispatchGuard.statusEnum) status: GuardStatus;
	@Mobile.State CoverRequest: Guard;
	
	@Mobile.Mutation toggleLeftSidebarVisibility: () => void;
	
	@Mobile.Getter("getGuardId") guardId: number;
	@Mobile.Mutation("setCallSign") setCallsign: (callSign: string) => void;

	
	private show: boolean = false;
	public showCallsignModal: boolean = false;

	private get isCovering(): boolean {
		// Note, a guard with status covering should be logged out immediately
		return (Boolean(this.originalCallSign) && !this.CoverRequest) || this.status == GuardStatus.Covering;
	}

	private get coverRequested(): boolean {
		return this.status == GuardStatus.CoveringRequested;
	}

	@Watch("mobileMode")
	onMobileModeChanged(value: string, oldValue: string) {
		if (value && value === "dispatch") {
			this.show = true;
		} else {
			this.show = false;
		}
	}

	public get cannotChangeStatus(): boolean {
		return this.status == GuardStatus.Arrived
			|| this.status == GuardStatus.EnRoute
			|| this.status == GuardStatus.Covering
			|| this.status == GuardStatus.Covered
			|| this.status == GuardStatus.CoveringRequested
	}

	public async switchCallsign()
	{			
		await mobileApi.removeUserFromGuard(this.guardId);

		this.setCallsign("");
		
		this.toggleLeftSidebarVisibility();
	}

	public availabilityToggleClicked() {
		// @techdebt - this is for a future development
		if (this.isCoverAvailable) {
			return;
		}

		if (this.cannotChangeStatus) {
			this.$emit("pick-unavailable", false);
			return;
		}

		if (this.onDuty) {
			this.$emit("pick-unavailable", true);
			this.loadUnavailableStatuses();
		} else {
			this.setOnDuty(true);
			this.guardAvailable();
		}
	}
}
